<button mat-flat-button class="accent transparent hide-mobile" tabindex="-1">{{ 'common.viewMore' | translate }}</button>
<app-circle-arrow-button class="hide-tablet" [isStatic]="true"></app-circle-arrow-button>
